import {
  onClickPay,
  payType,
  ServiceSubCategory,
  serviceType,
  historyType,
  getMoreViolations,
  getViolations,
} from '@/commonTypes';
import React, { ReactNode, useState } from 'react';
import styles from '../styles.module.css';
import SingleViolationResult from '../ServiceDetails/ServiceResultViolation/SingleViolationResult';
import DropDownPlateCard from '@/components/pages/plates/MyPlatesContent/MyPlatesList/DropDownPlateCard';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import { useLayoutContext } from '@/context/LayoutContext';
import { formatTehranPersianDate } from '@/functions/formatTehranPersianDate';
import { Pill } from '@/components/general/Pill';
import MainIcons from '@/icons/main';
import Button from '@/components/common/Button';
import { subCategoryIdList } from '@/api/global';
import NoneViolationDetails from '@/components/pages/plates/MyPlatesContent/MyPlatesList/DropDownPlateCard/PlateDetails/NonViolationDetails';
import MyPlatesList from '@/components/pages/plates/MyPlatesContent/MyPlatesList';
import Loader from '@/components/common/Loader';

export default function ServiceHistory({
  data,
  history,
  count = 0,
  children,
  headerType = 'violation',
  historyType = 'normal',
  onClickPay,
  violationCount,
  getMoreViolations,
  getViolations,
  loadingViolations = false,
}: {
  data?: ServiceSubCategory | historyType;
  history?: historyType[] | any;
  count?: string | number;
  children?: ReactNode;
  headerType?: string;
  historyType?: 'normal' | 'myplates';
  onClickPay?: onClickPay;
  violationCount?: string | number;
  getMoreViolations?: getMoreViolations;
  getViolations?: getViolations;
  loadingViolations?: boolean;
}) {
  const [expandedViolation, setExpandedViolation] = useState<number | null | string>();
  const { paymentTypeList } = useLayoutContext();
  console.log('history==', history);
  console.log('data==', data);
  return (
    <div className={`${styles.historyList}`}>
      {history?.map((item: historyType, index: number) => (
        <DropDownPlateCard
          key={index}
          plateBtnClass={styles.plateBtnClass}
          // className={`${styles.dropDown}`}
          childClass={styles.dropdownChildClass}
          plate={headerType == 'violation' && item?.response}
          header={headerType != 'violation' && <p style={{ flex: '1 1' }}> استعلام {index + 1} </p>}
          open={expandedViolation == index}
          onToggle={() => {
            console.log(
              'hhhhhhhhhh========',
              expandedViolation,
              index,
              item?.items,
              item?.results,
              item?.id,
              historyType,
            );
            setExpandedViolation(expandedViolation == index ? -1 : index);
            if (
              historyType != 'myplates' &&
              !item?.items &&
              expandedViolation != index &&
              headerType == 'violation'
            ) {
              getViolations && getViolations(0, item?.id);
            }
            if (historyType == 'myplates' && !item?.results && expandedViolation != index) {
              // alert('!');
              getViolations && getViolations(0, item?.batch);
            }
          }}
          plateSize="xs"
          aside={
            <div className={`${styles.historyAside}`}>
              <p className={styles.date}>{formatTehranPersianDate(item?.created_at)}</p>
              <Pill color="var(--gray)" bg="var(--gray-bg)">
                <MainIcons.walletIcon fill="var(--gray)" width="14px" height="14px" />
                {paymentTypeList?.filter((x) => x?.id == item?.paymentId)?.[0]?.title}
              </Pill>
            </div>
          }
        >
          {historyType == 'myplates' ? (
            <MyPlatesList
              data={item}
              plateBtnClass={styles.myplateBtnClass}
              getMoreViolations={getMoreViolations}
              loadingViolations={loadingViolations}
            />
          ) : (
            <>
              {' '}
              {data?.key == subCategoryIdList.vehicle_fines ? (
                <SingleViolationResult
                  data={item}
                  key={index}
                  onClick={onClickPay}
                  disabledButton={true}
                  // violationCount={violationCount}
                  getMoreViolations={getMoreViolations}
                  getViolations={getViolations}
                  loadingViolations={loadingViolations}
                />
              ) : (
                <NoneViolationDetails response={item?.response} key={index} type={data?.key} />
              )}
            </>
          )}
          {loadingViolations &&
            ((historyType != 'myplates' && !item?.items) ||
              (historyType == 'myplates' && !item?.results)) && (
              <Loader className={`${styles.loader}`} />
            )}
        </DropDownPlateCard>
      ))}
    </div>
  );
}
